export const FETCH_ADMIN_DASHBOARD_REPORTS_REQUEST = "FETCH_ADMIN_DASHBOARD_REPORTS_REQUEST";
export const FETCH_ADMIN_DASHBOARD_REPORTS_SUCCESS = "FETCH_ADMIN_DASHBOARD_REPORTS_SUCCESS";
export const FETCH_ADMIN_DASHBOARD_REPORTS_FAILURE = "FETCH_ADMIN_DASHBOARD_REPORTS_FAILURE";

export const FETCH_CAHSHIER_DASHBOARD_REPORTS_REQUEST = "FETCH_CAHSHIER_DASHBOARD_REPORTS_REQUEST";
export const FETCH_CAHSHIER_DASHBOARD_REPORTS_SUCCESS = "FETCH_CAHSHIER_DASHBOARD_REPORTS_SUCCESS";
export const FETCH_CAHSHIER_DASHBOARD_REPORTS_FAILURE = "FETCH_CAHSHIER_DASHBOARD_REPORTS_FAILURE";
